import PopoverContent from './PopoverContent';
import { PopoverProvider, usePopover } from './PopoverContext';
import PopoverTrigger from './PopoverTrigger';

const Popover = {
  Content: PopoverContent,
  Trigger: PopoverTrigger,
  Layer: PopoverProvider,
};

export { Popover, usePopover };
